import { FC } from 'react';

import { t } from '@core/i18n';
import { WithStyles, withStyles } from '@core/theme/utils/with-styles';
import { DrawerOverlay, DrawerOverlayProps, DrawerOverlayTheme } from '@shared/components/drawer-overlay';

import { styles } from './ChangesDrawerOverlay.styles';

export interface ChangesDrawerOverlayProps extends WithStyles<typeof styles> {
  buttons: DrawerOverlayProps['buttons'];
  theme?: DrawerOverlayProps['theme'];
  heading?: DrawerOverlayProps['heading'];
  message?: DrawerOverlayProps['message'];
}

const ChangesDrawerOverlayComponent: FC<ChangesDrawerOverlayProps> = ({
  classes,
  buttons,
  heading,
  message,
  theme = DrawerOverlayTheme.warning,
}) => {
  return (
    <DrawerOverlay
      classes={{
        root: classes.root,
        iconContainer: classes.iconContainer,
        icon: classes.icon,
        heading: classes.heading,
        message: classes.message,
      }}
      buttons={buttons}
      theme={theme}
      heading={heading || t('are_you_sure_you_want_to_leave_question')}
      message={message || t('by_leaving_now_you_will_lose_all_of_your_progress')}
    />
  );
};

export const ChangesDrawerOverlay = withStyles(styles)(ChangesDrawerOverlayComponent);
